<div class="container-fluid">
	<div *ngIf="infoId=='DOWNLOAD'">
		<div class="row">
			<div class="col-12 center-lines">
				<p>
					<br><br><br>
					Nous sommes désolé mais il n'est pas possible de télécharger le fichier suivant:<br />
				</p>
			</div>
			<br>
			<div class="col-12">
					<p>
						Merci de transmettre les informations suivantes à votre administrateur:<br>
					</p>
					<ul>
						<li>Fichier: {{fileName}}</li>
						<li>Dossier: {{folderName}}</li>
					</ul>
					<p>
						N'hésitez pas à revenir vers nous si vous avez des questions.<br>
						L'équipe de l'Atelier Bellet de Pina
					</p>
			</div>
		</div>
	</div>

	<div *ngIf="infoId=='FOLDER-FOLLOW'">
		<div class="row">
			<div class="col-12">
				<p>
					Bonjour <strong>{{userName}}</strong>,<br>
					<br>
					Nous accusons bien votre souhait de répondre au dossier <strong>{{folderName}}</strong>.<br>
					<br>
					Pour nous envoyer vos fichiers, merci d'utiliser cette même plateforme. Pour cela, merci de vous 
					connecter via l'adresse <a href="/login">Se connecter</a>.<br>
					<br>
					Pour rappel, votre identifiant est votre adresse email.<br>
					<br>
					A très bientôt!<br>
					L'équipe de l'Atelier Bellet de Pina
				</p>
			</div>
		</div>
	</div>

	<div *ngIf="infoId=='FOLDER-NOTFOLLOW'">
		<div class="row">
			<div class="col-12">
				<p>
					Bonjour <strong>{{userName}}</strong>,<br>
					<br>
					Nous accusons réception de votre souhait de ne <strong>pas</strong> répondre au dossier <strong>{{folderName}}</strong>.<br>
					<br>
					A très bientôt!<br>
					L'équipe de l'Atelier Bellet de Pina
				</p>
			</div>
		</div>
	</div>

	<div *ngIf="infoId=='DEFAULT' || infoId=='ERROR'">
		<div class="row">
			<div class="col-12 center-lines">
				<p>
					<br><br><br>
					Nous sommes désolé mais une erreur inattendue est apparue.<br>
					<br>
					Merci de contacter votre administrateur.
				</p>
			</div>
		</div>
	</div>
</div>

